import { render, staticRenderFns } from "./DialogAddFeedback.vue?vue&type=template&id=7cd8e77b"
import script from "./DialogAddFeedback.vue?vue&type=script&lang=js"
export * from "./DialogAddFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports